export const translations = {
  configuracoes: {
    pt: 'Configurações',
    en: 'Settings',
    de: 'Einstellungen',
    es: 'Configuración',
  },
  novoCliente: {
    pt: 'Novo cliente',
    en: 'New customer',
    de: 'Neuer Kunde',
    es: 'Nuevo cliente',
  },
  exportar: {
    pt: 'Exportar',
    en: 'Export',
    de: 'Exportieren',
    es: 'Exportar',
  },
  id: {
    pt: 'ID',
    en: 'ID',
    de: 'ID',
    es: 'ID',
  },
  cnpjCpf: {
    pt: 'CNPJ/CPF',
    en: 'CNPJ/CPF',
    de: 'CNPJ/CPF',
    es: 'CNPJ/CPF',
  },
  customerSegment: {
    pt: 'Segmento do Cliente',
    en: 'Customer Segment',
    de: 'Kundensegment',
    es: 'Segmento del Cliente',
  },
  razaoSocial: {
    pt: 'Razão Social',
    en: 'Company Name',
    de: 'Firmenname',
    es: 'Razón Social',
  },
  codigoSap: {
    pt: 'Cód. Sap',
    en: 'SAP Code',
    de: 'SAP-Code',
    es: 'Código SAP',
  },
  pais: {
    pt: 'País',
    en: 'Country',
    de: 'Land',
    es: 'País',
  },
  trade_name: {
    pt: 'Nome Fantasia',
    en: 'Trade Name',
    de: 'Handelsname',
    es: 'Nombre Comercial',
  },
  inscricao_estadual: {
    pt: 'Inscrição Estadual',
    en: 'State Registration',
    de: 'Umsatzsteuer-ID',
    es: 'Registro Estatal',
  },
  phone_number: {
    pt: 'Telefone',
    en: 'Phone Number',
    de: 'Telefonnummer',
    es: 'Número de Teléfono',
  },
  email: {
    pt: 'Email',
    en: 'Email',
    de: 'E-Mail',
    es: 'Correo Electrónico',
  },
  address_zipcode: {
    pt: 'CEP',
    en: 'ZIP Code',
    de: 'Postleitzahl',
    es: 'Código Postal',
  },
  address_street: {
    pt: 'Logradouro',
    en: 'Street',
    de: 'Straße',
    es: 'Calle',
  },
  address_number: {
    pt: 'Número',
    en: 'Number',
    de: 'Nummer',
    es: 'Número',
  },
  address_neighborhood: {
    pt: 'Bairro',
    en: 'Neighborhood',
    de: 'Stadtteil',
    es: 'Barrio',
  },
  address_state: {
    pt: 'UF',
    en: 'State',
    de: 'Bundesland',
    es: 'Estado',
  },
  address_city: {
    pt: 'Cidade',
    en: 'City',
    de: 'Stadt',
    es: 'Ciudad',
  },
  latitude: {
    pt: 'Latitude',
    en: 'Latitude',
    de: 'Breitengrad',
    es: 'Latitud',
  },
  longitude: {
    pt: 'Longitude',
    en: 'Longitude',
    de: 'Längengrad',
    es: 'Longitud',
  },
  observation: {
    pt: 'Observação',
    en: 'Observation',
    de: 'Beobachtung',
    es: 'Observación',
  },
};
